<template>
  <div id="app">
    <div class="loading-overlay" id="loading">
      <div class="loading-spinner">
        <div class="loading-circle"></div>
        <div class="loading-icon">🎵</div>
      </div>
      <p class="loading-text">Loading...</p>
    </div>

    <header class="header" v-if="!isLegalPage">
      <div class="logo">
        <img src="@/assets/logo.png" alt="Logo" class="favicon">
        <h1>Hi Ringtone Maker - ring app</h1>
      </div>
      <nav class="main-nav">
        <!-- Navigation menu removed -->
      </nav>
    </header>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLegalPage() {
      return this.$route.path === '/privacy' || this.$route.path === '/terms';
    }
  },
  mounted() {
    // 设置固定显示2秒
    setTimeout(() => {
      const loader = document.getElementById('loading');
      if (loader) {
        loader.classList.add('loading-fade-out');
        setTimeout(() => {
          loader.style.display = 'none';
        }, 500);
      }
    }, 2000);
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Noto+Sans+SC:wght@300;400;500;600;700&display=swap');

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes floatPhone {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(1deg);
  }
  100% {
    transform: translateY(0px) rotate(0deg);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 127, 102, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(255, 127, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 127, 102, 0);
  }
}

@keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', 'Noto Sans SC', sans-serif;
  color: #333;
  line-height: 1.6;
  background-color: #fcfcfc;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  background-color: rgba(255, 255, 255, 0.95);
  color: #555;
  padding: 1.2rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-image: none;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: -2rem;
}

.favicon {
  width: 40px;
  height: 40px;
  margin-right: 16px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.logo h1 {
  font-size: 2.2rem;
  font-weight: 700;
  background: linear-gradient(120deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
  text-align: center;
}

.main-nav ul {
  display: flex;
  list-style: none;
}

.main-nav li {
  margin-left: 1.5rem;
}

.main-nav a {
  color: #555;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s, opacity 0.3s;
  position: relative;
  padding: 0.5rem 0;
  opacity: 0.9;
}

.main-nav a:hover {
  color: #ff7f66;
  opacity: 1;
}

.main-nav a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background-color: #ff7f66;
  transition: width 0.3s ease;
}

.main-nav a:hover::after {
  width: 100%;
}

main {
  flex: 1;
}

.hero-section {
  background: linear-gradient(135deg, #f0f9ff, #e5f3ff);
  color: #555;
  padding: 7rem 2rem 5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 25% 25%, rgba(255, 127, 102, 0.08) 0%, transparent 45%),
    radial-gradient(circle at 75% 75%, rgba(255, 127, 102, 0.08) 0%, transparent 45%),
    linear-gradient(to right, rgba(240, 249, 255, 0.5) 0%, rgba(229, 243, 255, 0.5) 100%);
  z-index: 0;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-content h2 {
  font-size: 3.8rem;
  margin-bottom: 1rem;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  background: linear-gradient(120deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  animation: fadeInUp 1s ease-out;
  letter-spacing: -0.5px;
}

.hero-content p {
  font-size: 1.5rem;
  margin-bottom: 2.5rem;
  font-weight: 300;
  opacity: 0.9;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  animation: fadeInUp 1s ease-out 0.3s backwards;
}

.search-box {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
}

.search-box input {
  flex: 1;
  padding: 0.8rem 1rem;
  border: none;
  border-radius: 4px 0 0 4px;
  font-size: 1rem;
}

.search-box button {
  background-color: #f50057;
  color: white;
  border: none;
  padding: 0 1.5rem;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.search-box button:hover {
  background-color: #c51162;
}

.ringtones-section, .categories-section, .new-section {
  padding: 4rem 2rem;
}

.ringtones-section h2, .categories-section h2, .new-section h2 {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
  color: #424242;
}

.ringtones-grid, .categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.footer {
  background-color: #fff;
  color: #555;
  padding: 0;
  border-top: 1px solid #f0f0f0;
  position: relative;
  overflow: hidden;
}

.footer-wave {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  line-height: 0;
  overflow: hidden;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 2rem 3rem;
  position: relative;
  z-index: 1;
}

.footer-main {
  max-width: 350px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}

.footer-favicon {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.footer-description {
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.footer-copyright {
  color: #888;
  font-size: 0.9rem;
}

.footer-links {
  display: flex;
  gap: 4rem;
}

.footer-links-col h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #ff7f66;
  position: relative;
}

.footer-links-col h4::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  border-radius: 10px;
}

.footer-links-col ul {
  list-style: none;
}

.footer-links-col li {
  margin-bottom: 0.8rem;
}

.footer-links-col a {
  color: #666;
  text-decoration: none;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
}

.footer-links-col a::before {
  content: '•';
  position: absolute;
  left: -15px;
  color: #ff7f66;
  opacity: 0;
  transition: all 0.3s;
}

.footer-links-col a:hover {
  color: #ff7f66;
  transform: translateX(15px);
}

.footer-links-col a:hover::before {
  opacity: 1;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  color: #666;
}

.contact-icon {
  margin-right: 10px;
  font-size: 1.1rem;
}

.contact-email {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.contact-email:hover {
  color: #ff7f66;
}

.copyright-bar {
  background-color: #fafafa;
  padding: 1.2rem 0;
  text-align: center;
  border-top: 1px solid #f0f0f0;
}

.copyright-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  color: #888;
  font-size: 0.9rem;
}

.policy-links {
  display: flex;
  align-items: center;
}

.policy-links a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.policy-links a:hover {
  color: #ff7f66;
}

.divider {
  margin: 0 10px;
  color: #ddd;
}

@media (max-width: 768px) {
  .hero-content h2 {
    font-size: 2.5rem;
  }
  
  .footer-content {
    flex-direction: column;
    padding: 4rem 1.5rem 2rem;
  }
  
  .footer-main {
    margin-bottom: 3rem;
    text-align: center;
    max-width: 100%;
  }
  
  .footer-logo {
    justify-content: center;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 2rem;
    width: 100%;
  }
  
  .footer-links-col {
    text-align: center;
  }
  
  .footer-links-col h4::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .contact-item {
    justify-content: center;
  }
  
  .copyright-content {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 414px) {
  .hero-content h2 {
    font-size: 2rem;
  }
  
  .logo h1 {
    font-size: 1.8rem;
  }
}

.app-actions {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 4rem;
  animation: fadeInUp 1s ease-out 0.6s backwards;
}

.download-btn, .learn-more-btn {
  padding: 1rem 2.2rem;
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.download-btn {
  background: linear-gradient(120deg, #ff7f66, #ff6651);
  color: white;
  border: none;
  box-shadow: 0 8px 20px rgba(255, 127, 102, 0.25);
  animation: pulse 2.5s infinite;
}

.learn-more-btn {
  background-color: rgba(255, 255, 255, 0.8);
  color: #555;
  border: 1px solid rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.download-btn:hover {
  background: linear-gradient(120deg, #ff6651, #ff5540);
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(255, 127, 102, 0.35);
}

.learn-more-btn:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.app-preview {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
}

.app-preview::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 127, 102, 0.08) 0%, transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.phone-mockup {
  width: 320px;
  height: 650px;
  background-color: #333;
  border-radius: 40px;
  padding: 12px;
  margin: 0 auto;
  box-shadow: 
    0 30px 60px rgba(0, 0, 0, 0.15), 
    0 15px 30px rgba(0, 0, 0, 0.1),
    inset 0 2px 10px rgba(255, 255, 255, 0.1);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  animation: floatPhone 8s ease-in-out infinite, fadeInUp 1.5s ease-out 0.9s backwards;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.phone-screen {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.1);
}

.app-screenshot {
  width: 100%;
  height: 100%;
  background: url('./assets/app-preview.svg');
  background-size: cover;
  background-position: center;
}

.features-section, .screenshots-section, .download-section {
  padding: 7rem 2rem;
  text-align: center;
}

.features-section {
  background-color: #fff;
  position: relative;
}

.features-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 10% 90%, rgba(255, 127, 102, 0.03) 0%, transparent 60%);
  z-index: 0;
}

.screenshots-section {
  background-color: #fafafa;
  position: relative;
}

.screenshots-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 90% 10%, rgba(255, 127, 102, 0.03) 0%, transparent 60%);
  z-index: 0;
}

.download-section {
  background: linear-gradient(135deg, #f0f9ff, #e5f3ff);
  color: #555;
  position: relative;
  overflow: hidden;
}

.download-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 25% 25%, rgba(255, 127, 102, 0.08) 0%, transparent 45%),
    radial-gradient(circle at 75% 75%, rgba(255, 127, 102, 0.08) 0%, transparent 45%);
  z-index: 0;
}

.features-section h2, .screenshots-section h2, .community-section h2, .creation-section h2, .resource-section h2, .tutorial-section h2 {
  font-size: 3.2rem;
  margin-bottom: 1.2rem;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 700;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
}

.features-section h2::after, .screenshots-section h2::after, .community-section h2::after, .creation-section h2::after, .resource-section h2::after, .tutorial-section h2::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 25%;
  width: 50%;
  height: 3px;
  background: linear-gradient(135deg, rgba(255, 127, 102, 0.5), rgba(255, 170, 153, 0.5));
  border-radius: 10px;
}

.download-section h2 {
  font-size: 3.2rem;
  margin-bottom: 1.2rem;
  color: #ff7f66;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
}

.features-section p.section-subtitle,
.screenshots-section p.section-subtitle,
.download-section p.section-subtitle,
.community-section p.section-subtitle,
.creation-section p.section-subtitle,
.resource-section p.section-subtitle,
.tutorial-section p.section-subtitle {
  font-size: 1.2rem;
  margin-bottom: 4rem;
  color: #666;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1;
  font-weight: 300;
  line-height: 1.8;
}

.download-section p.section-subtitle {
  color: #666;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2.5rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.feature-card {
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: transform 0.4s, box-shadow 0.4s;
  border: 1px solid rgba(240, 240, 240, 0.8);
  animation: fadeInUp 0.8s ease-out backwards;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  pointer-events: none;
}

.features-grid > div:nth-child(1) {
  animation-delay: 0.1s;
}

.features-grid > div:nth-child(2) {
  animation-delay: 0.3s;
}

.features-grid > div:nth-child(3) {
  animation-delay: 0.5s;
}

.features-grid > div:nth-child(4) {
  animation-delay: 0.7s;
}

.features-grid > div:nth-child(5) {
  animation-delay: 0.9s;
}

.features-grid > div:nth-child(6) {
  animation-delay: 1.1s;
}

.feature-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.feature-icon {
  font-size: 3.2rem;
  margin-bottom: 1.5rem;
  display: inline-block;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.feature-card h3 {
  margin-bottom: 1.2rem;
  color: #333;
  font-weight: 600;
  font-size: 1.4rem;
}

.feature-card p {
  color: #666;
  line-height: 1.8;
}

.screenshot-slider {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
}

.screenshot-item {
  width: 240px;
  text-align: center;
}

.screenshot-phone {
  width: 240px;
  height: 480px;
  background-color: #555;
  border-radius: 30px;
  padding: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 15px 30px rgba(255, 127, 102, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  animation: fadeInUp 0.8s ease-out backwards;
  position: relative;
  overflow: hidden;
}

.screenshot-phone::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-color: #555;
  border-radius: 30px 30px 0 0;
  z-index: 1;
}

.screenshot-phone::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 4px;
  background-color: #444;
  border-radius: 4px;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.screenshot-phone:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(255, 127, 102, 0.12);
}

.screenshot-image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-size: cover;
  background-position: center;
}

.screenshot-1 {
  background: url('./assets/英语1.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-2 {
  background: url('./assets/英语2.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-3 {
  background: url('./assets/英语3.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-4 {
  background: url('./assets/英语4.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-5 {
  background: url('./assets/英语5.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-6 {
  background: url('./assets/英语6.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-7 {
  background: url('./assets/英语7.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-8 {
  background: url('./assets/英语8.jpg');
  background-size: cover;
  background-position: center top;
}

.screenshot-slider > div:nth-child(1) .screenshot-phone {
  animation-delay: 0.1s;
}

.screenshot-slider > div:nth-child(2) .screenshot-phone {
  animation-delay: 0.3s;
}

.screenshot-slider > div:nth-child(3) .screenshot-phone {
  animation-delay: 0.5s;
}

.screenshot-slider > div:nth-child(4) .screenshot-phone {
  animation-delay: 0.7s;
}

.screenshot-slider > div:nth-child(5) .screenshot-phone {
  animation-delay: 0.9s;
}

.screenshot-slider > div:nth-child(6) .screenshot-phone {
  animation-delay: 1.1s;
}

.download-content {
  max-width: 800px;
  margin: 0 auto;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease-out backwards;
}

.store-button {
  display: flex;
  align-items: center;
  background-color: rgba(80, 80, 80, 0.6);
  color: white;
  padding: 0.9rem 1.8rem;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
}

.store-button:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  background-color: rgba(80, 80, 80, 0.7);
}

.store-icon {
  font-size: 2.2rem;
  margin-right: 1rem;
}

.store-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.get-text {
  font-size: 0.7rem;
  margin-bottom: 2px;
}

.store-name {
  font-size: 1.2rem;
  font-weight: 500;
}

.store-button:first-child {
  animation-delay: 0.2s;
}

.store-button:last-child {
  animation-delay: 0.4s;
}

.hero-features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
  animation: fadeInUp 1s ease-out 0.4s backwards;
}

.hero-feature-item {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 0.8rem 1.4rem;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(255, 127, 102, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);
  transition: transform 0.3s, box-shadow 0.3s;
}

.hero-feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(255, 127, 102, 0.12);
}

.hero-feature-icon {
  font-size: 1.3rem;
  margin-right: 0.8rem;
}

.hero-feature-text {
  font-size: 1rem;
  font-weight: 500;
}

.hero-description {
  font-size: 1.15rem;
  margin-bottom: 3rem;
  font-weight: 300;
  opacity: 0.9;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  animation: fadeInUp 1s ease-out 0.5s backwards;
  line-height: 1.8;
  color: #444;
}

.community-section {
  background-color: #fff;
  padding: 5rem 2rem;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.community-content {
  max-width: 1200px;
  margin: 0 auto;
}

.community-section h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 700;
}

.community-section p.section-subtitle {
  font-size: 1.1rem;
  margin-bottom: 3.5rem;
  color: #666;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.community-features {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2.5rem;
  margin-top: 3rem;
}

.community-feature {
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(255, 127, 102, 0.04);
  max-width: 320px;
  transition: transform 0.3s;
  animation: fadeInUp 0.8s ease-out backwards;
}

.community-feature:nth-child(1) {
  animation-delay: 0.1s;
}

.community-feature:nth-child(2) {
  animation-delay: 0.3s;
}

.community-feature:nth-child(3) {
  animation-delay: 0.5s;
}

.community-feature:hover {
  transform: translateY(-10px);
}

.community-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: inline-block;
}

.community-feature h3 {
  margin-bottom: 1rem;
  color: #444;
  font-weight: 600;
  font-size: 1.3rem;
}

.community-feature p {
  color: #666;
  line-height: 1.7;
}

.creation-section {
  background-color: #ffffff;
  padding: 5rem 2rem;
  text-align: center;
}

.creation-section h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 700;
}

.creation-section p.section-subtitle {
  font-size: 1.1rem;
  margin-bottom: 3.5rem;
  color: #666;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.creation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.creation-item {
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(255, 127, 102, 0.04);
  transition: transform 0.3s, box-shadow 0.3s;
  border: 1px solid rgba(255, 127, 102, 0.03);
  animation: fadeInUp 0.8s ease-out backwards;
}

.creation-item:nth-child(1) {
  animation-delay: 0.1s;
}

.creation-item:nth-child(2) {
  animation-delay: 0.2s;
}

.creation-item:nth-child(3) {
  animation-delay: 0.3s;
}

.creation-item:nth-child(4) {
  animation-delay: 0.4s;
}

.creation-item:nth-child(5) {
  animation-delay: 0.5s;
}

.creation-item:nth-child(6) {
  animation-delay: 0.6s;
}

.creation-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 25px rgba(255, 127, 102, 0.08);
}

.creation-icon {
  font-size: 2.8rem;
  margin-bottom: 1.2rem;
  display: inline-block;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.creation-item h3 {
  margin-bottom: 1rem;
  color: #444;
  font-weight: 600;
  font-size: 1.3rem;
}

@media (max-width: 768px) {
  .community-features {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
  
  .community-feature {
    width: 100%;
    max-width: 100%;
    padding: 2rem;
  }
  
  .creation-grid {
    grid-template-columns: 1fr;
  }
  
  .creation-item {
    padding: 1.5rem;
  }
}

.resource-section {
  background-color: #f0f9ff;
  padding: 5rem 2rem;
  text-align: center;
}

.resource-section h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 700;
}

.resource-section p.section-subtitle {
  font-size: 1.1rem;
  margin-bottom: 3.5rem;
  color: #666;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.resource-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.resource-item {
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(255, 127, 102, 0.04);
  transition: transform 0.3s;
  animation: fadeInUp 0.8s ease-out backwards;
}

.resource-item:nth-child(1) {
  animation-delay: 0.1s;
}

.resource-item:nth-child(2) {
  animation-delay: 0.3s;
}

.resource-item:nth-child(3) {
  animation-delay: 0.5s;
}

.resource-item:nth-child(4) {
  animation-delay: 0.7s;
}

.resource-item:nth-child(5) {
  animation-delay: 0.9s;
}

.resource-item:nth-child(6) {
  animation-delay: 1.1s;
}

.resource-item:hover {
  transform: translateY(-10px);
}

.resource-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: inline-block;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.resource-item h3 {
  margin-bottom: 1rem;
  color: #444;
  font-weight: 600;
  font-size: 1.3rem;
}

.resource-item p {
  color: #666;
  line-height: 1.7;
}

.tutorial-section {
  background-color: #ffffff;
  padding: 5rem 2rem;
  text-align: center;
}

.tutorial-content {
  max-width: 1200px;
  margin: 0 auto;
}

.tutorial-section h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ff7f66, #ffaa99);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 700;
}

.tutorial-section p.section-subtitle {
  font-size: 1.1rem;
  margin-bottom: 3.5rem;
  color: #666;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.tutorial-features {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2.5rem;
}

.tutorial-feature {
  background-color: #fff;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(255, 127, 102, 0.04);
  max-width: 320px;
  transition: transform 0.3s;
  animation: fadeInUp 0.8s ease-out backwards;
}

.tutorial-feature:nth-child(1) {
  animation-delay: 0.1s;
}

.tutorial-feature:nth-child(2) {
  animation-delay: 0.3s;
}

.tutorial-feature:nth-child(3) {
  animation-delay: 0.5s;
}

.tutorial-feature:nth-child(4) {
  animation-delay: 0.7s;
}

.tutorial-feature:nth-child(5) {
  animation-delay: 0.9s;
}

.tutorial-feature:nth-child(6) {
  animation-delay: 1.1s;
}

.tutorial-feature:hover {
  transform: translateY(-10px);
}

.tutorial-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: inline-block;
}

.tutorial-feature h3 {
  margin-bottom: 1rem;
  color: #444;
  font-weight: 600;
  font-size: 1.3rem;
}

.tutorial-feature p {
  color: #666;
  line-height: 1.7;
}

.social-share {
  margin-top: 3rem;
  animation: fadeInUp 0.8s ease-out 0.7s backwards;
}

.social-share p {
  margin-bottom: 1rem;
  color: #666;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.social-icon {
  padding: 0.8rem 1.5rem;
  background-color: #fff;
  color: #666;
  text-decoration: none;
  border-radius: 50px;
  transition: all 0.3s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.social-icon:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  color: #ff7f66;
}

.app-subtitle {
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  color: #555;
  font-weight: 500;
  animation: fadeInUp 0.8s ease-out 0.3s backwards;
}

.keywords-tag {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease-out 0.4s backwards;
}

.keyword {
  padding: 0.4rem 1rem;
  background-color: rgba(255, 127, 102, 0.1);
  border-radius: 50px;
  font-size: 0.9rem;
  color: #666;
}

.footer ul {
  list-style: none;
}

.footer li {
  margin-bottom: 0.8rem;
}

@media (max-width: 768px) {
  .resource-container {
    grid-template-columns: 1fr;
  }
  
  .logo h1 {
    font-size:1.1rem;
  }

  .resource-item {
    padding: 2rem;
  }
  
  .tutorial-features {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
  
  .tutorial-feature {
    width: 100%;
    max-width: 100%;
    padding: 2rem;
  }
  
  .keywords-tag {
    padding: 0 1rem;
  }
  
  .footer-section:last-child {
    margin-top: 1.5rem;
  }
}

/* 加载动画样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f0f9ff, #e5f3ff);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s ease;
}

.loading-fade-out {
  opacity: 0;
}

.loading-spinner {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

.loading-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(255, 127, 102, 0.2);
  border-top: 4px solid #ff7f66;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

.loading-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2.5rem;
  animation: pulse 1.5s ease-in-out infinite;
}

.loading-text {
  color: #666;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 2px;
  animation: fadeInOut 1.5s ease-in-out infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.policy-link-btn {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  font-family: inherit;
  text-decoration: none;
  transition: color 0.3s;
}

.policy-link-btn:hover {
  color: #ff7f66;
}
</style>
